export function clearAllStorageAndCookies() {
  localStorage.clear()

  sessionStorage.clear()

  document.cookie.split(';').forEach(function (cookie) {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
    document.cookie =
      name.trim() + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/'
  })
}
